module.exports = __webpack_public_path__ + "images/emoji/rooster.368dd807dd031ac13018.png";